module.exports = __webpack_public_path__ + "media/images/faces/face20-04e5e54730771202dd403a2fc638bd68.jpg";